
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

let baseURL = ''; // api请求接口地址
let loginUrl = ''; // 微信登录链接 获取用户信息
let APPID = ''; // 微信登录appid
let wxServerUrl = ''; // 微信服务地址
let projectUrl = ''; //
let shareUrl = ''; // 分享地址
let medalUrl = ''; // 打卡地址

if (process.env.NODE_ENV === 'development') {
    // baseURL = 'http://dev.platforms.makeblock.com'
    baseURL = '//platforms-test.makeblock.com';
    //   baseURL = '//platforms-dev.makeblock.com'
    loginUrl = '//passport-test.makeblock.com';
    APPID = 'wx5c760f125e075c50';
    wxServerUrl = '//wxservice-test.makeblock.com';
    projectUrl = '//boxcheckin-test.makeblock.com/community?t=0';
    shareUrl = 'http://hezi-dev.makeblock.com:8080/#/share-guide';
    medalUrl = 'http://hezi-dev.makeblock.com:8080/#/medal-guide';
}
if (process.env.NODE_ENV === 'test') {
    baseURL = '//platforms-test.makeblock.com';
    loginUrl = '//passport-test.makeblock.com';
    APPID = 'wx5c760f125e075c50';
    wxServerUrl = '//wxservice-test.makeblock.com';
    projectUrl = '//boxcheckin-test.makeblock.com/community?t=0';
    shareUrl = 'http://test-web.makeblock.com/box/index.html#/share-guide';
    medalUrl = 'http://test-web.makeblock.com/box/index.html#/medal-guide';
}
if (process.env.NODE_ENV === 'production') {
    baseURL = '//platforms.makeblock.com';
    loginUrl = '//passport2.makeblock.com';
    APPID = 'wx88c7abff9480ae61';
    wxServerUrl = '//wxservice.makeblock.com';
    projectUrl = '//boxcheckin.makeblock.com/community?t=0';
    shareUrl = 'https://hezi.makeblock.com/#/share-guide';
    medalUrl = 'https://hezi.makeblock.com/#/medal-guide';
}

export default {
    baseURL,
    loginUrl,
    APPID,
    wxServerUrl,
    projectUrl,
    shareUrl,
    medalUrl
};
